import React, { useContext } from 'react';

import assetModalContext from '@components/asset/modal/tabs/edit/asset_modal_context';

import {
  ActionTypes,
  AssetDetailsDispatch,
} from '@components/asset/modal/tabs/edit/EditTabTypes';

import { GenericFileData } from '@api/v4/assets/assetTypes';

import RadioButton from '@components/common/radio_button/main';

interface ThreeSixtyViewerScopedContext {
  state: {
    editState: {
      genericFileData: GenericFileData;
    };
  };
  dispatch: AssetDetailsDispatch;
}

const ThreeSixtyViewerComponent = (): React.ReactElement => {
  const { state, dispatch }: ThreeSixtyViewerScopedContext = useContext(assetModalContext);
  /* eslint-disable @typescript-eslint/camelcase */
  const { genericFileData } = state.editState;
  const { three_sixty_viewer } = genericFileData;

  const updateThreeSixtyViewer = (value: boolean): void => {
    const payload = {
      genericFileData: {
        ...genericFileData,
        three_sixty_viewer: value
      }
    };

    dispatch({ type: ActionTypes.UpdateAsset, payload });
  };

  return (
    <div className="asset-advanced__feature threesixty-viewer-setting">
      <span>360&#176; {t("Viewer")}</span>
      <div className="radio-button-container">
        <RadioButton
          checkedButton={three_sixty_viewer ? 'Enable' : 'Disable'}
          labelCopy={t("Enabled")}
          name="three-sixty-viewer"
          onChangeFunction={(): void => updateThreeSixtyViewer(true)}
          valueCopy="Enable"
        />
        <RadioButton
          checkedButton={three_sixty_viewer ? 'Enable' : 'Disable'}
          labelCopy={t("Disabled")}
          name="three-sixty-viewer"
          onChangeFunction={(): void => updateThreeSixtyViewer(false)}
          valueCopy="Disable"
        />
      </div>
    </div>
  );
};

export default ThreeSixtyViewerComponent;
